export class DataLayerController {

	push(data) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(data);
	}

	// -----------------------------------------------------------------------------------------------------------------
	// STEP ORDER

	pushStepOrderOpenConfiguratorPopup() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Tištěný kupón|Otevření popupu',
			'eventLabel': undefined,
		});
	}

	pushStepOrderCheckDiscountCode() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Slevový kód',
			'eventLabel': 'Zaškrtnutí: Mám zájem',
		});
	}

	pushStepOrderCheckDiscountPass() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Senior pas a Family pas',
			'eventLabel': 'Zaškrtnutí: Mám zájem',
		});
	}

	pushStepOrderCheckRecreationVouchers() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Rekreační příspěvek',
			'eventLabel': 'Zaškrtnutí: Mám zájem',
		});
	}

	pushStepOrderCheckInvoiceInBillingInfo() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Nákup na firmu',
			'eventLabel': 'Zaškrtnutí: Mám zájem',
		});
	}

	pushStepOrderPaymentTwistoShowMoreInfo() {
		this.push({
			'event': 'ga.event',
			'eventCategory': 'Cart',
			'eventAction': 'Twisto',
			'eventLabel': 'Více o Twistu',
		});
	}
}

if (typeof window.DataLayerController !== 'function') {
	window.DataLayerController = new DataLayerController();
}
